(function () {
  const config = window.osnWishlistConfig || {};
  const apiBaseUrl = (config.apiBaseUrl || '').replace(/\/$/, '');
  const storageKey = config.storageKey || 'osn-saved-items-v1';
  const alertStorageKey = config.alertStorageKey || 'osn-restock-alerts-v1';
  const currencyCode = config.currencyCode || '';
  const localeCode = String(config.localeCode || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const text = config.locale || {};
  const liveText = ({
    en: { checking: 'Checking current availability…', unknown: 'Open the product to check availability.', changed: 'Options have changed. Open the product to choose.', checkCart: 'We could not confirm the addition. Check your cart before adding again.', added: 'Added to your cart.', viewCart: 'View cart', addAgain: 'Add another', savedOnly: 'Saved items are not reserved. Prices and availability are checked when you open this list.' },
    fr: { checking: 'Vérification de la disponibilité…', unknown: 'Ouvrez la fiche pour vérifier la disponibilité.', changed: 'Les options ont changé. Ouvrez la fiche pour choisir.', checkCart: 'L’ajout n’a pas pu être confirmé. Vérifiez votre panier avant de réessayer.', added: 'Ajouté à votre panier.', viewCart: 'Voir le panier', addAgain: 'Ajouter un autre', savedOnly: 'Les articles enregistrés ne sont pas réservés. Les prix et la disponibilité sont vérifiés à l’ouverture de cette liste.' },
    es: { checking: 'Consultando la disponibilidad…', unknown: 'Abre el producto para consultar la disponibilidad.', changed: 'Las opciones han cambiado. Abre el producto para elegir.', checkCart: 'No pudimos confirmar que se añadiera. Revisa tu carrito antes de intentarlo de nuevo.', added: 'Añadido a tu carrito.', viewCart: 'Ver carrito', addAgain: 'Añadir otro', savedOnly: 'Los artículos guardados no están reservados. Los precios y la disponibilidad se consultan al abrir esta lista.' }
  })[localeCode] || null;
  // Unsupported storefront languages use English, not translation keys.
  const copy = liveText || { checking: 'Checking current availability…', unknown: 'Open the product to check availability.', changed: 'Options have changed. Open the product to choose.', checkCart: 'We could not confirm the addition. Check your cart before adding again.', added: 'Added to your cart.', viewCart: 'View cart', addAgain: 'Add another', savedOnly: 'Saved items are not reserved. Prices and availability are checked when you open this list.' };
  const checked = new Map();
  const additions = new Map();
  let refreshGeneration = 0;
  const drawer = document.querySelector('[data-osn-wishlist-drawer]');
  const drawerList = drawer ? drawer.querySelector('[data-osn-wishlist-list]') : null;
  const drawerSummary = drawer ? drawer.querySelector('[data-osn-wishlist-summary]') : null;
  const alertList = drawer ? drawer.querySelector('[data-osn-alert-list]') : null;
  const savedTabCount = drawer ? drawer.querySelector('[data-osn-saved-tab-count]') : null;
  const alertTabCount = drawer ? drawer.querySelector('[data-osn-alert-tab-count]') : null;
  const launcherCountNodes = Array.from(document.querySelectorAll('[data-osn-wishlist-count]'));
  const state = {
    items: [],
    alerts: [],
    hydrated: false,
    alertsHydrated: false,
    activeElement: null,
  };

  function readStorage() {
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('wishlist storage read failed', error);
      return [];
    }
  }

  function writeStorage(items) {
    state.items = items;
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      console.warn('wishlist storage write failed', error);
    }
  }

  function getAlerts() {
    if (!state.alertsHydrated) {
      try {
        const raw = window.localStorage.getItem(alertStorageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        state.alerts = Array.isArray(parsed) ? parsed : [];
      } catch (_error) {
        state.alerts = [];
      }
      state.alertsHydrated = true;
    }
    return state.alerts.slice();
  }

  function setAlerts(alerts) {
    const seen = new Map();
    alerts.forEach((alert) => {
      if (!alert || !alert.product_id) return;
      seen.set(variantKey(alert.product_id, alert.variant_id), alert);
    });
    state.alerts = Array.from(seen.values());
    try {
      window.localStorage.setItem(alertStorageKey, JSON.stringify(state.alerts));
    } catch (error) {
      console.warn('restock alert storage write failed', error);
    }
    renderAll();
  }

  function variantKey(productId, variantId) {
    return String(productId) + ':' + String(variantId || 'default');
  }

  function uniqueItems(items) {
    const seen = new Map();
    items.forEach((item) => {
      if (!item || !item.product_id) return;
      seen.set(variantKey(item.product_id, item.variant_id), item);
    });
    return Array.from(seen.values());
  }

  function getItems() {
    if (!state.hydrated) {
      state.items = uniqueItems(readStorage());
      state.hydrated = true;
    }
    return state.items.slice();
  }

  function setItems(items) {
    writeStorage(uniqueItems(items));
    renderAll();
  }

  function upsertItem(item) {
    const items = getItems().filter((entry) => variantKey(entry.product_id, entry.variant_id) !== variantKey(item.product_id, item.variant_id));
    items.push(item);
    setItems(items);
  }

  function removeItem(productId, variantId) {
    const items = getItems().filter((entry) => variantKey(entry.product_id, entry.variant_id) !== variantKey(productId, variantId));
    setItems(items);
  }

  function findItem(productId, variantId) {
    return getItems().find((entry) => variantKey(entry.product_id, entry.variant_id) === variantKey(productId, variantId)) || null;
  }

  function moneyFromCents(cents) {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'CAD',
      }).format(amount);
    } catch (_error) {
      return '$' + amount.toFixed(2);
    }
  }

  function productUrl(pathOrUrl) {
    if (!pathOrUrl) return '#';
    try {
      const url = new URL(pathOrUrl, window.location.origin);
      if (url.origin !== window.location.origin) return '#';
      const path = url.pathname.replace(/^\/(?:fr|es)(?=\/|$)/, '');
      if (!path.startsWith('/products/')) return '#';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (['fr', 'es'].includes(localeCode) ? '/' + localeCode + '/' : '/');
      return root.replace(/\/$/, '') + path + url.search;
    } catch (_) { return '#'; }
  }

  function cartUrl() { return (window.routes && window.routes.cart_url) || (localeCode === 'en' ? '/cart' : '/' + localeCode + '/cart'); }

  async function currentItem(item) {
    const path = productUrl(item.product_url || '/products/' + item.handle);
    if (path === '#') throw new Error('Invalid saved product route');
    const url = new URL(path, location.origin);
    url.search = '?section_id=osn-saved-product-data';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Product unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(doc.querySelector('[data-osn-saved-product-data]').textContent);
      const product = data.product;
      if (String(product.id) !== String(item.product_id) || !Array.isArray(product.variants)) throw new Error('Product identity changed');
      const variant = product.variants.find(entry => String(entry.id) === String(item.variant_id));
      return { ...item, product_title: product.title, product_url: path, image_url: product.featured_image || item.image_url,
        available: !!variant && variant.available === true && !product.requires_selling_plan,
        price_text: '', price_cents: variant ? variant.price : null,
        pack_text: data.pack_text || '', variant_title: variant ? variant.title : '', changed: !variant || !!product.requires_selling_plan };
    } finally { clearTimeout(timer); }
  }

  async function refreshSavedItems() {
    const generation = ++refreshGeneration;
    const queue = getItems();
    checked.clear(); renderDrawer();
    // Three bounded reads at a time, only when the customer opens the drawer.
    async function worker() {
      while (queue.length && generation === refreshGeneration) {
        const item = queue.shift(); const key = variantKey(item.product_id, item.variant_id);
        let result;
        try { result = await currentItem(item); } catch (_) { result = { ...item, available: false, price_text: '', price_cents: null, unknown: true }; }
        if (generation !== refreshGeneration || !findItem(item.product_id, item.variant_id)) continue;
        checked.set(key, result); renderDrawer();
      }
    }
    await Promise.all([worker(), worker(), worker()]);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatText(template, values) {
    return Object.keys(values || {}).reduce((result, key) => {
      return result.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), String(values[key]));
    }, String(template || ''));
  }

  async function apiFetch(path, options) {
    if (!apiBaseUrl) return null;
    const response = await fetch(apiBaseUrl + path, Object.assign({
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }, options || {}));
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || ('API ' + response.status));
    }
    if (response.status === 204) return null;
    return response.json();
  }

  async function syncAdd(item) {
    try {
      await apiFetch('/api/wishlist/items', {
        method: 'POST',
        body: JSON.stringify(item),
      });
    } catch (error) {
      console.warn('wishlist add sync failed', error);
    }
  }

  async function syncRemove(item) {
    try {
      const query = new URLSearchParams({ product_id: String(item.product_id) });
      if (item.variant_id) query.set('variant_id', String(item.variant_id));
      await apiFetch('/api/wishlist/items?' + query.toString(), {
        method: 'DELETE',
      });
    } catch (error) {
      console.warn('wishlist remove sync failed', error);
    }
  }

  async function hydrateFromApi() {
    if (!apiBaseUrl) return;
    try {
      const payload = await apiFetch('/api/wishlist');
      const remoteItems = Array.isArray(payload && payload.items) ? payload.items : [];
      const localItems = getItems();
      if (remoteItems.length && !localItems.length) {
        setItems(remoteItems);
        return;
      }
      if (localItems.length && !remoteItems.length) {
        await apiFetch('/api/wishlist/sync', {
          method: 'POST',
          body: JSON.stringify({ items: localItems, replace: true }),
        });
        return;
      }
      const merged = uniqueItems(localItems.concat(remoteItems));
      if (merged.length !== localItems.length) {
        setItems(merged);
      }
    } catch (error) {
      console.warn('wishlist hydrate failed', error);
    }
  }

  function renderLauncherCounts() {
    const count = getItems().length;
    launcherCountNodes.forEach((node) => {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
  }

  function renderDrawer() {
    if (!drawer || !drawerList) return;
    const focused = document.activeElement;
    const focusCard = drawerList.contains(focused) && focused.closest('[data-osn-item-key]');
    const focusKey = focusCard && focusCard.dataset.osnItemKey;
    const focusIndex = focusCard ? Array.from(focusCard.querySelectorAll('a,button')).indexOf(focused) : -1;
    const items = getItems().slice().sort((a, b) => (b.saved_at || '').localeCompare(a.saved_at || ''));
    const alerts = getAlerts();
    if (drawerSummary) {
      drawerSummary.textContent = formatText(
        alerts.length === 1 ? text.summaryOne : text.summaryMany,
        { saved: items.length, alerts: alerts.length }
      );
    }
    if (savedTabCount) savedTabCount.textContent = String(items.length);
    if (alertTabCount) alertTabCount.textContent = String(alerts.length);
    if (!items.length) {
      drawerList.innerHTML = '<div class="osn-wishlist-drawer__empty"><p class="h4">' + escapeHtml(text.emptySavedHeading) + '</p><p>' + escapeHtml(text.emptySavedCopy) + '</p></div>';
      return;
    }
    drawerList.innerHTML = items.map((savedItem) => {
      const key = variantKey(savedItem.product_id, savedItem.variant_id);
      const item = checked.get(key) || { ...savedItem, available: false, price_text: '', price_cents: null };
      const adding = additions.get(key);
      const image = item.image_url
        ? '<a class="osn-wishlist-item__media" href="' + escapeHtml(productUrl(item.product_url)) + '"><img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>'
        : '<a class="osn-wishlist-item__media" href="' + escapeHtml(productUrl(item.product_url)) + '"></a>';
      const availabilityClass = item.available ? 'is-in-stock' : 'is-out-of-stock';
      const availabilityText = !checked.has(key) ? copy.checking : item.unknown ? copy.unknown : item.changed ? copy.changed : item.available ? text.available : text.unavailable;
      const addDisabled = item.available && item.variant_id && adding !== 'pending' && adding !== 'uncertain' ? '' : ' disabled';
      const price = item.price_text || (typeof item.price_cents === 'number' ? moneyFromCents(item.price_cents) : '');
      return '' +
        '<article class="osn-wishlist-item" data-osn-item-key="' + escapeHtml(variantKey(item.product_id, item.variant_id)) + '">' +
          image +
          '<div>' +
            '<h3 class="osn-wishlist-item__title"><a href="' + escapeHtml(productUrl(item.product_url)) + '">' + escapeHtml(item.product_title || item.handle) + '</a></h3>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="osn-wishlist-item__meta">' + escapeHtml(item.variant_title) + '</p>' : '') +
            (item.pack_text && item.variant_title === 'Default Title' ? '<p class="osn-wishlist-item__meta">' + escapeHtml(item.pack_text) + '</p>' : '') +
            (price ? '<p class="osn-wishlist-item__meta">' + escapeHtml(price) + '</p>' : '') +
            '<p class="osn-wishlist-item__availability ' + availabilityClass + '">' + availabilityText + '</p>' +
            '<div class="osn-wishlist-item__actions">' +
              '<button type="button" class="osn-wishlist-drawer__action" data-osn-add-to-cart data-product-id="' + escapeHtml(item.product_id) + '" data-variant-id="' + escapeHtml(item.variant_id || '') + '"' + addDisabled + '>' + escapeHtml(adding === 'added' ? copy.addAgain : text.addToCart) + '</button>' +
              '<a class="osn-wishlist-drawer__secondary" href="' + escapeHtml(productUrl(item.product_url)) + '">' + escapeHtml(text.viewProduct) + '</a>' +
              '<button type="button" class="osn-wishlist-drawer__secondary" data-osn-remove-item data-product-id="' + escapeHtml(item.product_id) + '" data-variant-id="' + escapeHtml(item.variant_id || '') + '">' + escapeHtml(text.remove) + '</button>' +
            '</div>' +
            (adding && adding !== 'pending' ? '<p class="osn-wishlist-item__feedback" role="status">' + escapeHtml(adding === 'added' ? copy.added : copy.checkCart) + ' <a data-osn-wishlist-cart href="' + escapeHtml(cartUrl()) + '">' + escapeHtml(copy.viewCart) + '</a></p>' : '') +
          '</div>' +
        '</article>';
    }).join('');
    if (focusKey && focusIndex >= 0) {
      const card = Array.from(drawerList.querySelectorAll('[data-osn-item-key]')).find(node => node.dataset.osnItemKey === focusKey);
      const target = card && card.querySelectorAll('a,button')[focusIndex];
      if (target && !target.disabled) target.focus({ preventScroll: true });
    }
  }

  function renderAlerts() {
    if (!alertList) return;
    const alerts = getAlerts().slice().sort((a, b) => (b.saved_at || '').localeCompare(a.saved_at || ''));
    if (!alerts.length) {
      alertList.innerHTML = '<div class="osn-wishlist-drawer__empty"><p class="h4">' + escapeHtml(text.emptyAlertsHeading) + '</p><p>' + escapeHtml(text.emptyAlertsCopy) + '</p></div>';
      return;
    }
    alertList.innerHTML = alerts.map((item) => {
      const image = item.image_url
        ? '<a class="osn-wishlist-item__media" href="' + escapeHtml(productUrl(item.product_url)) + '"><img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>'
        : '<a class="osn-wishlist-item__media" href="' + escapeHtml(productUrl(item.product_url)) + '"></a>';
      return '<article class="osn-wishlist-item">' + image + '<div><h3 class="osn-wishlist-item__title"><a href="' + escapeHtml(productUrl(item.product_url)) + '">' + escapeHtml(item.product_title || item.handle) + '</a></h3><p class="osn-wishlist-item__availability is-out-of-stock">' + escapeHtml(text.alertOn) + '</p><p class="osn-wishlist-item__meta">' + escapeHtml(item.email || '') + '</p><div class="osn-wishlist-item__actions"><a class="osn-wishlist-drawer__action" href="' + escapeHtml(productUrl(item.product_url)) + '">' + escapeHtml(text.viewProduct) + '</a><button type="button" class="osn-wishlist-drawer__secondary" data-osn-remove-alert data-product-id="' + escapeHtml(item.product_id) + '" data-variant-id="' + escapeHtml(item.variant_id || '') + '">' + escapeHtml(text.removeAlert) + '</button></div></div></article>';
    }).join('');
  }

  function renderButtons() {
    document.querySelectorAll('[data-osn-save-button]').forEach((button) => {
      const context = button.closest('[data-osn-product-actions], [data-osn-card-save]');
      if (!context) return;
      const productId = Number(context.getAttribute('data-product-id'));
      const variantId = Number(context.getAttribute('data-variant-id') || '') || null;
      const isSaved = !!findItem(productId, variantId);
      button.classList.toggle('is-saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      const label = button.querySelector('[data-osn-save-label]');
      if (label) label.textContent = isSaved ? text.saved : text.saveForLater;
      if (!label) {
        button.setAttribute('aria-label', isSaved ? text.removeSavedAria : text.saveForLater);
      }
    });
  }

  function renderAll() {
    renderButtons();
    renderLauncherCounts();
    renderDrawer();
    renderAlerts();
  }

  function collectProductItem(context) {
    const productId = Number(context.getAttribute('data-product-id'));
    const variantId = Number(context.getAttribute('data-variant-id') || '') || null;
    const priceCents = Number(context.getAttribute('data-price-cents') || '') || null;
    return {
      product_id: productId,
      variant_id: variantId,
      handle: context.getAttribute('data-handle') || '',
      product_title: context.getAttribute('data-title') || '',
      variant_title: context.getAttribute('data-variant-title') || '',
      product_url: context.getAttribute('data-url') || '',
      image_url: context.getAttribute('data-image') || '',
      price_text: context.getAttribute('data-price-text') || '',
      price_cents: priceCents,
      available: String(context.getAttribute('data-available')) === 'true',
      source: context.getAttribute('data-source') || 'theme',
      saved_at: new Date().toISOString(),
      metadata: { locale: localeCode },
    };
  }

  async function handleSaveToggle(button) {
    const context = button.closest('[data-osn-product-actions], [data-osn-card-save]');
    if (!context) return;
    const item = collectProductItem(context);
    const statusNode = context.querySelector('[data-osn-status]');
    const saved = !!findItem(item.product_id, item.variant_id);
    button.disabled = true;
    try {
      if (saved) {
        removeItem(item.product_id, item.variant_id);
        await syncRemove(item);
        if (statusNode) {
          statusNode.textContent = text.removedStatus;
          statusNode.className = 'osn-saved-actions__status is-success';
        }
      } else {
        upsertItem(item);
        await syncAdd(item);
        if (statusNode) {
          statusNode.textContent = text.savedStatus;
          statusNode.className = 'osn-saved-actions__status is-success';
        }
      }
    } finally {
      button.disabled = false;
      renderAll();
    }
  }

  async function addWishlistItemToCart(variantId, button) {
    if (!variantId) return;
    const productId = button.getAttribute('data-product-id');
    const key = variantKey(productId, variantId);
    if (['pending', 'uncertain'].includes(additions.get(key))) return;
    const item = findItem(productId, variantId);
    if (!item) return;
    additions.set(key, 'pending'); renderDrawer();
    let attempted = false;
    const controller = new AbortController();
    let timer;
    try {
      const fresh = await currentItem(item);
      checked.set(key, fresh);
      if (!fresh.available) { additions.delete(key); renderDrawer(); return; }
      attempted = true;
      timer = setTimeout(() => controller.abort(), 15000);
      const response = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        signal: controller.signal,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });
      if (!response.ok) throw new Error('Add to cart failed');
      const result = await response.json();
      if (result.status || !Array.isArray(result.items) || !result.items.some(entry => String(entry.variant_id || entry.id) === String(variantId))) throw new Error('Unconfirmed add response');
      additions.set(key, 'added');
      await updateCartBubble();
    } catch (error) {
      console.warn('wishlist add to cart failed', error);
      if (attempted) additions.set(key, 'uncertain');
      else { additions.delete(key); checked.set(key, { ...item, available: false, price_text: '', price_cents: null, unknown: true }); }
    } finally { clearTimeout(timer); renderDrawer(); }
  }

  async function updateCartBubble() {
    try {
      const response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const header = document.querySelector('#cart-icon-bubble');
      if (header && header.classList.contains('tool-button')) {
        header.querySelectorAll('.tool-button__count,.cart-count-bubble').forEach(node => node.remove());
        if (cart.item_count > 0) {
          const count = document.createElement('span'); count.className = 'tool-button__count'; count.textContent = String(cart.item_count); header.appendChild(count);
        }
      }
      if (typeof window.refreshOsnCardCartState === 'function') window.refreshOsnCardCartState();
      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (!bubble) return;
      const visible = bubble.querySelector('span[aria-hidden="true"]');
      const sr = bubble.querySelector('.visually-hidden');
      if (visible) visible.textContent = String(cart.item_count);
      if (sr) sr.textContent = formatText(text.cartItems, { count: cart.item_count });
      bubble.style.display = cart.item_count ? '' : 'none';
    } catch (error) {
      console.warn('cart bubble refresh failed', error);
    }
  }

  async function submitStockReminder(form) {
    const statusNode = form.parentElement.querySelector('[data-osn-stock-status]');
    const submit = form.querySelector('button[type="submit"]');
    const emailInput = form.querySelector('input[type="email"]');
    const context = form.closest('[data-osn-product-actions]');
    if (!context || !emailInput) return;
    submit.disabled = true;
    if (statusNode) {
      statusNode.textContent = text.savingReminder;
      statusNode.className = 'osn-stock-reminder__status';
    }
    try {
      await apiFetch('/api/stock-reminders', {
        method: 'POST',
        body: JSON.stringify({
          email: emailInput.value.trim(),
          product_id: Number(context.getAttribute('data-product-id')),
          variant_id: Number(context.getAttribute('data-variant-id') || '') || null,
          handle: context.getAttribute('data-handle') || '',
          product_title: context.getAttribute('data-title') || '',
          variant_title: context.getAttribute('data-variant-title') || '',
          product_url: context.getAttribute('data-url') || '',
          image_url: context.getAttribute('data-image') || '',
          price_text: context.getAttribute('data-price-text') || '',
          source: 'product-page',
          locale: localeCode,
          metadata: { locale: localeCode },
        }),
      });
      setAlerts(getAlerts().concat([{
        email: emailInput.value.trim(),
        product_id: Number(context.getAttribute('data-product-id')),
        variant_id: Number(context.getAttribute('data-variant-id') || '') || null,
        handle: context.getAttribute('data-handle') || '',
        product_title: context.getAttribute('data-title') || '',
        variant_title: context.getAttribute('data-variant-title') || '',
        product_url: context.getAttribute('data-url') || '',
        image_url: context.getAttribute('data-image') || '',
        locale: localeCode,
        saved_at: new Date().toISOString(),
      }]));
      if (statusNode) {
        statusNode.textContent = text.reminderSaved;
        statusNode.className = 'osn-stock-reminder__status is-success';
      }
      form.reset();
    } catch (error) {
      console.warn('stock reminder save failed', error);
      if (statusNode) {
        statusNode.textContent = text.reminderError;
        statusNode.className = 'osn-stock-reminder__status is-error';
      }
    } finally {
      submit.disabled = false;
    }
  }

  function setProductContextFromVariant(container, variant) {
    if (!container || !variant) return;
    container.setAttribute('data-variant-id', String(variant.id || ''));
    container.setAttribute('data-variant-title', variant.title || '');
    container.setAttribute('data-available', variant.available ? 'true' : 'false');
    container.setAttribute('data-price-cents', String(typeof variant.price === 'number' ? variant.price : ''));
    container.setAttribute('data-price-text', moneyFromCents(Number(variant.price || 0)));
    const reminder = container.querySelector('[data-osn-stock-reminder]');
    if (reminder) reminder.hidden = !!variant.available;
  }

  function initProductActions() {
    document.querySelectorAll('[data-osn-product-actions]').forEach((container) => {
      const variantScriptId = container.getAttribute('data-variants-json');
      const variantInputSelector = container.getAttribute('data-variant-input');
      const variantInput = variantInputSelector ? document.querySelector(variantInputSelector) : null;
      const variantScript = variantScriptId ? document.getElementById(variantScriptId) : null;
      let variants = [];
      try {
        variants = variantScript ? JSON.parse(variantScript.textContent) : [];
      } catch (_error) {
        variants = [];
      }
      function syncVariantFromForm() {
        const variantId = Number(variantInput && variantInput.value ? variantInput.value : container.getAttribute('data-variant-id') || 0);
        const variant = variants.find((entry) => Number(entry.id) === variantId) || variants[0];
        if (variant) {
          setProductContextFromVariant(container, variant);
          renderButtons();
        }
      }
      if (variantInput) {
        variantInput.addEventListener('change', syncVariantFromForm);
      }
      document.addEventListener('variant:change', syncVariantFromForm);
      document.addEventListener('variant:changed', syncVariantFromForm);
      syncVariantFromForm();
    });
  }

  function emailWishlist() {
    const items = getItems();
    if (!items.length) return;
    const lines = items.map((item) => '- ' + (item.product_title || item.handle) + ': ' + productUrl(item.product_url));
    const subject = encodeURIComponent(text.emailSubject);
    const body = encodeURIComponent(lines.join('\n'));
    window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
  }

  function copyWishlist() {
    const items = getItems();
    if (!items.length || !navigator.clipboard) return;
    const lines = items.map((item) => (item.product_title || item.handle) + ' — ' + productUrl(item.product_url));
    navigator.clipboard.writeText(lines.join('\n'));
  }

  function openDrawer() {
    if (!drawer) return;
    if (drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.body.classList.add('overflow-hidden');
    }
    state.activeElement = document.activeElement;
    renderAll();
    const selectedTab = drawer.querySelector('[data-osn-utility-tab][aria-selected="true"]');
    if (selectedTab) selectedTab.focus();
    if (!drawer.querySelector('[data-osn-saved-confidence]')) {
      const note = document.createElement('p'); note.className = 'osn-wishlist-drawer__footer-note';
      note.dataset.osnSavedConfidence = ''; note.textContent = copy.savedOnly;
      drawer.querySelector('.osn-wishlist-drawer__footer').appendChild(note);
    }
    refreshSavedItems();
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    ++refreshGeneration;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (state.activeElement && typeof state.activeElement.focus === 'function') state.activeElement.focus();
    state.activeElement = null;
  }

  function selectUtilityTab(name) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-osn-utility-tab]').forEach((tab) => {
      const selected = tab.getAttribute('data-osn-utility-tab') === name;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    drawer.querySelectorAll('[data-osn-utility-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-osn-utility-panel') !== name;
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-osn-wishlist-cart]')) closeDrawer();
    const saveButton = event.target.closest('[data-osn-save-button]');
    if (saveButton) {
      event.preventDefault();
      handleSaveToggle(saveButton);
      return;
    }
    const openButton = event.target.closest('[data-osn-wishlist-open], [data-osn-wishlist-launcher]');
    if (openButton) {
      event.preventDefault();
      openDrawer();
      return;
    }
    const closeButton = event.target.closest('[data-osn-wishlist-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    const utilityTab = event.target.closest('[data-osn-utility-tab]');
    if (utilityTab) {
      event.preventDefault();
      selectUtilityTab(utilityTab.getAttribute('data-osn-utility-tab'));
      return;
    }
    const removeButton = event.target.closest('[data-osn-remove-item]');
    if (removeButton) {
      event.preventDefault();
      removeItem(Number(removeButton.getAttribute('data-product-id')), Number(removeButton.getAttribute('data-variant-id')) || null);
      syncRemove({
        product_id: Number(removeButton.getAttribute('data-product-id')),
        variant_id: Number(removeButton.getAttribute('data-variant-id')) || null,
      });
      return;
    }
    const addButton = event.target.closest('[data-osn-add-to-cart]');
    if (addButton) {
      event.preventDefault();
      addWishlistItemToCart(addButton.getAttribute('data-variant-id'), addButton);
      return;
    }
    const removeAlertButton = event.target.closest('[data-osn-remove-alert]');
    if (removeAlertButton) {
      event.preventDefault();
      const productId = Number(removeAlertButton.getAttribute('data-product-id'));
      const variantId = Number(removeAlertButton.getAttribute('data-variant-id')) || null;
      setAlerts(getAlerts().filter((item) => variantKey(item.product_id, item.variant_id) !== variantKey(productId, variantId)));
      return;
    }
    const emailButton = event.target.closest('[data-osn-wishlist-email]');
    if (emailButton) {
      event.preventDefault();
      emailWishlist();
      return;
    }
    const copyButton = event.target.closest('[data-osn-wishlist-copy]');
    if (copyButton) {
      event.preventDefault();
      copyWishlist();
    }
  });

  document.addEventListener('submit', function (event) {
    const reminderForm = event.target.closest('[data-osn-stock-form]');
    if (reminderForm) {
      event.preventDefault();
      submitStockReminder(reminderForm);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')).filter((node) => !node.closest('[hidden]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener('osn:product-actions-added', renderButtons);
  document.addEventListener('DOMContentLoaded', function () {
    getItems();
    getAlerts();
    initProductActions();
    renderAll();
    hydrateFromApi();
  });
})();
